import { env } from 'env';

export const links = {
  get imagesBaseUrl() {
    return env.REACT_APP_STATIC_ASSETS_URL || '';
  },
  salesforce: 'https://perimeter81.lightning.force.com/lightning/r',
  freshdeskTickets: 'https://perimeter81.freshdesk.com/a/tickets/',
  helpCenter: 'https://perimeter81.atlassian.net/l/c',
  innerIcons: 'https://static.perimeter81.com/api/files/',
  firewallGranularityPlaybook:
    'https://perimeter81.atlassian.net/wiki/spaces/RD/pages/2261778492/Firewall+Logging+Granularity+-+Migration+Playbook#Workflow'
};

export const BIDataExists = !env.REACT_APP_BI_DATA_NOT_EXISTS;

/**
 * List of roles that supported only by platform
 **/
export const platformRoles = {
  ADMIN_DEMO: 'Admin Demo',
  ADMIN: 'Admin',
  OWNER: 'Owner',
  USER: 'User',
  MANAGER: 'Manager',
  BILLING: 'Billing'
};

export const jarvisRoleNames = {
  Jarvis_Developer: 'Jarvis Developer',
  User: 'User',
  Agents_Platform_Developer: 'Agents Platform Developer',
  Core_Developer: 'Core Developer',
  Product_Manager: 'Product Manager',
  Read_Only: 'Read Only',
  CS_User: 'CS User',
  CS_Admin: 'CS Admin',
  NOC_User: 'NOC User',
  SRE_User: 'SRE User'
};
